import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const PatentFamilySchema = z.object({
  patentFamilyId: z.string(),
  title: z.string(),
  abstract: z.string().nullable(),
  description: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PatentFamily = z.infer<typeof PatentFamilySchema>;

export const PatentFamiliesSchema = z.array(PatentFamilySchema);

export type PatentFamilies = z.infer<typeof PatentFamiliesSchema>;

export const PatentFamiliesQuerySchema =
  createOffsetPaginationRequestQuerySchema(
    z.enum(['title', 'createdAt', 'updatedAt']),
  ).merge(
    z.object({
      titleLike: z.string().optional(),
      patentFamilyIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    }),
  );

export type PatentFamiliesQuery = z.infer<typeof PatentFamiliesQuerySchema>;

export const CreatePatentFamilySchema = PatentFamilySchema.pick({
  title: true,
  abstract: true,
  description: true,
});

export type CreatePatentFamily = z.infer<typeof CreatePatentFamilySchema>;
